import { Component, OnInit } from '@angular/core';
import { Globals } from 'src/app/global';

@Component({
  selector: 'app-loan-purpose',
  templateUrl: './loan-purpose.component.html',
  styleUrls: ['./loan-purpose.component.scss']
})
export class LoanPurposeComponent implements OnInit {

  constructor(public globals: Globals) { }

  section_modal: string = '';

  ngOnInit() {
    var modal=this.globals.getModalValue();
    if(undefined!=modal){
      this.section_modal=modal;
    }
  }

  setValue(value) {
    this.globals.setValue(value);
  }
}
